// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__QnZ6x","unreadBadge":"styles_unreadBadge__2NEPn","modalContent":"styles_modalContent__2dwFJ","modal":"styles_modal__1Pwo2"};